module.exports = __webpack_public_path__ + "745a97fb64f3a8c340f3c1d5547a9aa9.pdf";